import { render, staticRenderFns } from "./ModalProduction.vue?vue&type=template&id=3a8288dc"
import script from "./ModalProduction.vue?vue&type=script&lang=js"
export * from "./ModalProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports